module.exports = __webpack_public_path__ + "static/media/link.6b0c46b4.svg";